var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-row',[_c('v-col',[_c('personal-details',{attrs:{"rights":_vm.rights},on:{"userUpdated":_vm.userUpdated}})],1),_c('v-col',[_c('change-email',{attrs:{"rights":_vm.rights}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"offset":"6"}},[_c('change-password',{attrs:{"rights":_vm.rights,"user":_vm.user}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }